import { LoginFormI, ValidationSet } from '../../../../types/interface';
import { commonValidations } from '../validations';

export const LoginValidations: ValidationSet<LoginFormI> = {
  email: commonValidations.email,
  password: commonValidations.password
};
